import React, { useMemo, useEffect, useState } from 'react';
import { Banner, Footer, WisaFooterItem } from '@oceanjs/wisa';
import { AppHeader } from './components/AppHeader';
import { Downloader, DownloaderProvider } from '../Downloader';

import logo from '../../img/BML_Logo_srgb.svg';
import { AppEnvironmentService } from '../../api/environment';
import { ErrorPage, ErrorContainer } from '../../views/Misc';

export const Layout: React.FC = ({ children }) => {
  const [bannerInfo, setBannerInfo] = useState<{environment: string, version: string}>({environment: 'wisa.app.env', version: 'wisa.app.version'});
  useEffect(() =>  {
    const getInfo = async (): Promise<void> => {
      try {
        const result = await AppEnvironmentService.getEnv();
        setBannerInfo({environment: result.environment || 'wisa.app.env', version: result.version || 'wisa.app.version'});
      } catch(e) {
        console.log('environment info error');
      }
    }
    getInfo();
  },[]);

  const items: WisaFooterItem[] = useMemo(() => {
    return [
      { messageId: 'wisa.app.footer.home', link: '#/' },
      { messageId: 'wisa.app.footer.imprint', link: 'https://info.bml.gv.at/themen/wasser/wisa/impressum.html', target: '_blank' },
      { messageId: 'wisa.app.footer.privacy', link: '#/privacy' },
      { messageId: 'wisa.app.footer.accessibility', link: 'https://info.bml.gv.at/themen/wasser/wisa/barrierefreiheit', target: '_blank' },
      { messageId: 'wisa.app.footer.helpdesk', link: '#/helpdesk' }
    ]
  },[]);
  return (
    <>
      <Banner 
        image={<img src={logo} style={{ width: '250px', height: '68px' }} alt="logo" />}
        environment={bannerInfo.environment}
        version={bannerInfo.version}
      />
      <DownloaderProvider>
        <AppHeader />
        <Downloader />
        <ErrorContainer component={ErrorPage}>
          <main id="content" className="container-fluid" role="main" aria-live="assertive" style={{ minHeight: 'calc(-168px + 100vh)' }}>
            {children}
          </main>
        </ErrorContainer> 
      </DownloaderProvider>
      <Footer items={items} />
    </>
  );
};
